import { FC } from 'react'

import { VStack } from '@revolut-internal/ui-kit'

import { AgentAttendanceDetails } from './AgentAttendanceDetails'
import { AgentAttendanceIntervals } from './AgentAttendanceIntervals'

export const Agent: FC = () => {
  return (
    <VStack space="s-8">
      <AgentAttendanceDetails />
      <AgentAttendanceIntervals />
    </VStack>
  )
}
